import { render } from "./ReviewResultEmptyState.vue?vue&type=template&id=72637956&scoped=true"
import script from "./ReviewResultEmptyState.vue?vue&type=script&lang=js"
export * from "./ReviewResultEmptyState.vue?vue&type=script&lang=js"

import "./ReviewResultEmptyState.vue?vue&type=style&index=0&id=72637956&scoped=true&lang=scss"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72637956"],['__file',"src/scripts/view/review/components/ReviewResultEmptyState.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "72637956"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('72637956', __exports__)) {
    api.reload('72637956', __exports__)
  }
  
  module.hot.accept("./ReviewResultEmptyState.vue?vue&type=template&id=72637956&scoped=true", () => {
    api.rerender('72637956', render)
  })

}


export default __exports__